var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: {
      title: "Close Client Profile",
      showCustomTitle: _vm.isEdittingLocked,
    },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c("p", { staticClass: "-mt-3" }, [
              _vm._v(" All visits will be closed if you close this client "),
            ]),
            _c(
              "div",
              { staticClass: "flex pt-5 justify-end mt-3" },
              [
                _c("UIButton", {
                  staticClass: "mr-3",
                  attrs: {
                    variant: "outline",
                    fullWidth: true,
                    size: "md",
                    id: "cancelProject",
                    buttonClasses: "customButtonCard",
                    buttonText: "Cancel",
                  },
                  on: { click: _vm.closeModal },
                }),
                _c("UIButton", {
                  attrs: {
                    buttonText: "Close profile",
                    variant: "black",
                    size: "md",
                    buttonClasses: "customButtonCard",
                    id: "createNewProj",
                  },
                  on: { click: _vm.completeProject },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }